import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import DialogModal from '../../common/DialogModal';
import { HouseListDirectory } from '../../../constants/ComponentTypes';

const styles = () => ({
  contentContainer: {
    margin: '0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: '600px',
    justifyContent: 'center',
    padding: '50px 100px 70px 100px',
  },

  container: {
    marginTop: '55px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    height: '335px',
  },

  item: {
    flex: 1,
    margin: '0px 10px',
    background: '#FFFFFF',
    border: '1px solid #E7E9EB',
    borderRadius: '6px',
    height: '100%',
    width: '312px',
  },

  iconButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '312px',
    height: '210px',
    backgroundColor: 'white',
    cursor: 'pointer',
    borderBottom: '1px solid #E7E9EB',
    position: 'relative',
  },

  textContainer: {
    padding: '20px',
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  execListText: {
    marginTop: '8px',
    lineHeight: '20px',
    fontSize: '15px',
  },

  title: {
    fontWeight: 'bold',
    lineHeight: '17px',
    fontSize: '16px',
  },

  subheading: {
    marginTop: '8px',
    lineHeight: '14px',
    fontSize: '12px',
  },

  downloadExcel: {
    display: 'inline-flex',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: '14px',
    marginTop: '11px',
  },

  label: {
    position: 'absolute',
    top: 10,
    left: '50%',
    transform: 'translateX(-50%)',
    padding: '5px 42px',
    background: '#E7FAEF',
    border: '1px solid #3D8D5F',
    borderRadius: '2px',
    color: '#3D8D5F',
    fontSize: '13px',
  }
});

class AddAddressDialog extends React.Component {
  handleClick = (callback) => () => {
    this.props.toggleDialog();
    callback();
  }

  handleSalesforceClick = () => {
    const { user } = this.props;
    let salesforceIntegrationStatus = user && user.integrations ? user.integrations.salesforce : false;
    let salesforceIntegrationFlag = user && user.salesforce_integration_flag ? user.salesforce_integration_flag : false;

    if (!salesforceIntegrationFlag) {
      this.props.toggleInquiryDialog();
    } else if (salesforceIntegrationStatus) {
      this.props.goTo("/setting/integrations/salesforce");
    } else {
      window.open(process.env.REACT_APP_API_BASE_URL + "/oauth2/salesforce", "_self")
    }
  }

  handleDownloadTemplate = () => {
    if (this.props.type === HouseListDirectory.MAIN.name) {
      if (this.props.isFollowCallAddress) {
        window.open(process.env.REACT_APP_FOLLOW_CALL_ADDRESS_BOOK_EXCEL);
      } else {
        window.open(process.env.REACT_APP_ADDRESS_BOOK_EXCEL);
      }
    } else if (this.props.type === HouseListDirectory.NG_LIST.name) {
      window.open(process.env.REACT_APP_NG_LIST_EXCEL);
    }
  };

  render() {
    const {
      classes,
      toggleDialog,
      isOpen,
      type,
      user
    } = this.props;

    let name, formClick, excelClick;

    const salesforceIntegrationStatus = user && user.integrations ? user.integrations.salesforce : false;
    if (type === HouseListDirectory.NG_LIST.name) {
      name = "送付NGを新規登録";
      formClick = this.props.toggleCreateNgItemDialog;
      excelClick = this.props.toggleAddNgExcelDialog;
    } else {
      name = "アドレスを新規登録";
      formClick = this.props.toggleCreateDialog;
      excelClick = this.props.toggleAddExcelDialog;
    }

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          contentContainer: classes.contentContainer
        }}
      >
        <Typography variant="display1" style={{ fontSize: '18px' }}> {name}</Typography>
        <div className={classes.container}>
          <div className={classes.item}>
            <div className={classes.iconButton} onClick={this.handleClick(formClick)}>
              <img src={require('../../../assets/images/note-pencil.svg')} alt="フォーム入力" width="96px" />
            </div>
            <div className={classes.textContainer}>
              <Typography variant="body2" className={classes.title}>フォーム入力</Typography>
              <Typography variant="body1" className={classes.subheading}>1件ずつ手動で登録</Typography>
            </div>
          </div>

          <div className={classes.item}>
            <div className={classes.iconButton} onClick={this.handleClick(excelClick)}>
              <img src={require('../../../assets/images/excel.svg')} alt="Excelからインポート" width="80px" />
            </div>
            <div className={classes.textContainer}>
              <Typography variant="body2" className={classes.title}>Excelからインポート</Typography>
              <Typography variant="body1" className={classes.subheading}>Excelファイルから一括登録</Typography>

              <div className={classes.downloadExcel} onClick={this.handleDownloadTemplate}>
                <img src={require('../../../assets/images/download.svg')} alt="Excelからインポート" width="12.5px" />
                <Typography variant="body1" className={classes.subheading} style={{ color: "#1A65FF", margin: '0 0 0 4px' }}>専用ひな形をダウンロード</Typography>
              </div>
            </div>
          </div>

          {(() => {
            // TODO:フォローコールアドレスの場合のSFインポートは影響範囲が大きいため、別で実装する
            if (type === HouseListDirectory.MAIN.name && !this.props.isFollowCallAddress) {
              return (
                <div className={classes.item}>
                  <div className={classes.iconButton} onClick={this.handleSalesforceClick}>
                    {salesforceIntegrationStatus &&
                      <label className={classes.label}>連携済み</label>}
                    <img src={require('../../../assets/images/salesforce-logo.svg')} alt="Salesforceのリストをインポート" width="156px" />
                  </div>
                  <div className={classes.textContainer}>
                    <Typography variant="body2" className={classes.title}>Salesforceのリストをインポート</Typography>
                    <Typography variant="body1" className={classes.subheading}>
                      Salesforceで作成したリストを同期します。<br />
                      解除は、「マイアカウント ＞ 連携」からいつでも行えます。
                    </Typography>
                  </div>
                </div>
              )
            }
          })()}
        </div>
      </DialogModal>
    );
  }
}

AddAddressDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  toggleCreateDialog: PropTypes.func.isRequired,
  toggleAddExcelDialog: PropTypes.func.isRequired,
  toggleCreateNgItemDialog: PropTypes.func.isRequired,
  toggleAddNgExcelDialog: PropTypes.func.isRequired,
  toggleInquiryDialog: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  user: PropTypes.object,
  isFollowCallAddress: PropTypes.bool,
};

AddAddressDialog.defaultProps = {
  type: HouseListDirectory.MAIN.name,
  isFollowCallAddress: false
}

export default withStyles(styles)(AddAddressDialog);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/AddAddressDialog.jsx